/**
 * Druhy ryb, které jde chytit.
 *
 * Z 35 modelů v balíku je vybráno deset tak, aby se lišily siluetou —
 * na dálku, kdy ryba vyskočí nad hladinu na půl vteřiny, je tvar jediné,
 * co hráč stihne rozeznat. Barvy z modelů proto nechávám být a nemíchám
 * do výběru druhy, které vypadají skoro stejně (Tang, YellowTang, BlueTang
 * jsou tři varianty téhož tvaru — beru jednu).
 */

export interface FishType {
  /** Jméno objektu v fish.glb. */
  model: string;
  name: string;
  /**
   * Váha v losování. Součet se nemusí rovnat ničemu konkrétnímu —
   * pravděpodobnost je podíl z celku.
   */
  weight: number;
  /**
   * Měřítko modelu. Zdrojové modely mají 2,5 až 4,6 metru — v původní
   * velikosti by z karase byla dvoumetrová obluda. Hodnoty jsou naladěné
   * tak, aby běžná ryba měla kolem 70 cm a žralok necelé čtyři metry.
   */
  scale: number;
  /** Jak vzácný úlovek to je (pro barvu v hlášce). */
  rarity: 'bezna' | 'neobvykla' | 'vzacna' | 'legendarni';
}

export const FISH_TYPES: FishType[] = [
  { model: 'Goldfish', name: 'Karas zlatý', weight: 100, scale: 0.26, rarity: 'bezna' },
  { model: 'Tetra', name: 'Tetra', weight: 90, scale: 0.2, rarity: 'bezna' },
  { model: 'Piranha', name: 'Piraňa', weight: 70, scale: 0.28, rarity: 'bezna' },
  { model: 'Clownfish', name: 'Klaun očkatý', weight: 60, scale: 0.23, rarity: 'neobvykla' },
  { model: 'BlueTang', name: 'Bodlok pestrý', weight: 55, scale: 0.26, rarity: 'neobvykla' },
  { model: 'Koi', name: 'Kapr koi', weight: 40, scale: 0.4, rarity: 'neobvykla' },
  { model: 'Puffer', name: 'Čtverzubec', weight: 30, scale: 0.32, rarity: 'vzacna' },
  { model: 'Tuna', name: 'Tuňák', weight: 22, scale: 0.55, rarity: 'vzacna' },
  { model: 'Swordfish', name: 'Mečoun', weight: 10, scale: 0.7, rarity: 'legendarni' },
  { model: 'Shark', name: 'Žralok', weight: 4, scale: 0.85, rarity: 'legendarni' },
];

const TOTAL_WEIGHT = FISH_TYPES.reduce((sum, f) => sum + f.weight, 0);

/** Náhodný druh podle vah. */
export function rollFish(): FishType {
  let roll = Math.random() * TOTAL_WEIGHT;
  for (const fish of FISH_TYPES) {
    roll -= fish.weight;
    if (roll <= 0) return fish;
  }
  return FISH_TYPES[0];
}

export const RARITY_COLORS: Record<FishType['rarity'], string> = {
  bezna: '#c9d4e2',
  neobvykla: '#7ee08a',
  vzacna: '#6ea8ff',
  legendarni: '#d9b872',
};

export const RARITY_LABELS: Record<FishType['rarity'], string> = {
  bezna: 'běžná',
  neobvykla: 'neobvyklá',
  vzacna: 'vzácná',
  legendarni: 'legendární',
};
